import { Component } from 'react'
import styled from 'glamorous'
import { map } from 'lodash'

import { $ } from 'utils'
import { Icon, ImagePure } from 'components'


const Container = styled.div({
  position: 'relative',
  width: '100%',
  overflow: 'hidden',
  marginTop: 10,
}, 'cls-container')

const PersonList = styled.div({
  display: 'flex',
  flexFlow: 'row wrap',
  alignItems: 'flex-start',
  alignContent: 'flex-start',
  height: '100%'
})

const PersonContainer = styled.div({
  display: 'flex',
  alignItems: 'flex-start',
  marginTop: 5,
  cursor: 'pointer',
  '&:hover .photo-hover': {
    display: 'flex'
  }
}, ({ disabled }) => disabled && ({
  cursor: 'default'
}))

const PhotoContainer = styled.div({
  position: 'relative',
  minWidth: 62,
  height: 80,
  marginLeft: 2,
  marginBottom: 2,
})

const ImageContainer = styled.div({
  position: 'absolute',
})

const PhotoHover = styled.div({
  display: 'none',
  position: 'absolute',
  width: '100%',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center'
}, ({ isSelected }) => isSelected && ({
  display: 'flex'
}), 'photo-hover')

const ListInfo = styled.div({
  marginLeft: 15,
})

const ListName = styled.div({
  fontSize: 14,
  fontWeight: 'bold',
  whiteSpace: 'normal',
  wordBreak: 'break-word'
})

const ListId = styled.div({
  fontSize: 14,
  color: 'var(--grey)'
})


export default class PersonsPanelList extends Component {

  render = () => {
    const { selected, items, onSelect, locked = [] } = this.props
    return (
      $(Container,
        $(PersonList,
          map(items, (val, key) => {
            const isSelected = map(selected, i => i.uuid).includes(val.uuid)
            const negative = !isSelected && selected.length > 0
            const isDisabled = locked.includes(val.uuid)
            return (
              $(PersonContainer, { key: val.uuid, onClick: () => !isDisabled && onSelect(val), disabled: isDisabled },
                $(PhotoContainer,
                  $(ImageContainer,
                    $(ImagePure, {
                      src: val.portrait,
                      width: 62,
                      height: 80,
                      negative: negative || isDisabled,
                    }),
                  ),
                !isDisabled &&
                  $(PhotoHover, { isSelected },
                    $(Icon, {
                      type: 'confirm',
                      color: 'rgba(0, 0, 0, .7)',
                      colorHover: 'rgba(0, 0, 0, .7)',
                      isActive: isSelected
                    })
                  )
                ),
                $(ListInfo,
                  $(ListName, val.userData),
                  $(ListId, val.uuid)
                )
              )
            )
          })
        )
      )
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/panels/PersonsPanelList.js